import { SHARE_TYPES } from "@constants";

export function formatShareName(input) {
  switch (input) {
    case SHARE_TYPES.NORMAL:
      return 'Normal Share';
    case SHARE_TYPES.REGISTER:
      return 'Register Share';
    case SHARE_TYPES.TOPUP:
      return 'Top Up Share';
    case SHARE_TYPES.POCKET_MONEY:
      return 'Pocket Money Share';
    case SHARE_TYPES.SPIN:
      return 'Spin Share';
    case SHARE_TYPES.WITHDRAW:
      return 'Withdraw Share';
    default:
      return input;
  }
}
